// extracted by mini-css-extract-plugin
export var container = "solutionMobile-module--container--3gqDt";
export var subtitle = "solutionMobile-module--subtitle--1euct";
export var title = "solutionMobile-module--title--3pwMl";